import { useCallback } from "react";
import { Alert, Button, Loader, Stack, Text } from "@mantine/core";
import type { UseQueryResult } from "@tanstack/react-query";
import type { PendingWorkDetail } from "../../types/pendingWork";
import { pendingWorkError } from "../../services/pendingWork.service";
import { PendingWorkDetailItem } from "./PendingWorkDetailItem";

interface Props {
  details: PendingWorkDetail[];
  query: UseQueryResult<PendingWorkDetail[], Error>;
}
export function PendingWorkExpandedRow({ details, query }: Props) {
  const handleRetry = useCallback(() => {
    void query.refetch();
  }, [query]);
  return (
    <Stack gap="xs" p="sm" aria-label="Pending family causes">
      {query.isLoading && (
        <Loader size="sm" aria-label="Loading pending details" />
      )}
      {query.isError && (
        <Alert
          color="red"
          variant="light"
          title="Pending details unavailable"
          role="alert"
        >
          {pendingWorkError(query.error)}
          <Button size="xs" onClick={handleRetry} ml="sm">
            Try again
          </Button>
        </Alert>
      )}
      {details.map((detail) => (
        <PendingWorkDetailItem
          key={`${detail.kind}:${detail.ownerId}:${detail.id}`}
          detail={detail}
        />
      ))}
      {query.isSuccess && details.length === 0 && (
        <Text size="sm">No pending causes remain in this family.</Text>
      )}
    </Stack>
  );
}
